import { Modal } from "@/components/elements/Modal";
import { Stack, Typography } from "@mui/material";
import { FC, useEffect } from "react";
import { BlockerFunction, useBlocker, Location } from "react-router-dom";
import { UNSAVED_CHANGES_MESSAGE } from "@/constants/common";

type TConfirmLeavePageProps = {
  shouldBlock: boolean | BlockerFunction;
  callBackLeave?: () => void;
  customMessage?: string;
};

// Helper function to check if only query params changed
const isOnlyQueryParamsChanged = (currentLocation: Location, nextLocation: Location): boolean => {
  return currentLocation.pathname === nextLocation.pathname;
};

export const ConfirmLeavePage: FC<TConfirmLeavePageProps> = ({ shouldBlock, callBackLeave, customMessage }) => {
  // Wrap shouldBlock to skip blocking if only query params changed
  const modifiedShouldBlock: BlockerFunction = ({ currentLocation, nextLocation, historyAction }) => {
    if (typeof shouldBlock === "function") {
      // If shouldBlock is a function, call it but skip if only query params changed
      return !isOnlyQueryParamsChanged(currentLocation, nextLocation) && shouldBlock({ currentLocation, nextLocation, historyAction });
    }
    // If shouldBlock is a boolean, skip if only query params changed
    return !isOnlyQueryParamsChanged(currentLocation, nextLocation) && shouldBlock;
  };

  const blocker = useBlocker(modifiedShouldBlock);

  useEffect(() => {
    const beforeUnLoadHandler = (event: BeforeUnloadEvent) => {
      if (typeof shouldBlock === "function" || !shouldBlock) return;
      event.preventDefault();
      event.returnValue = UNSAVED_CHANGES_MESSAGE;
      return event;
    };
    window.addEventListener("beforeunload", beforeUnLoadHandler);
    return () => {
      window.removeEventListener("beforeunload", beforeUnLoadHandler);
    };
  }, [shouldBlock]);

  if (blocker.state === "blocked" && (typeof shouldBlock === "function" || shouldBlock)) {
    return (
      <Modal
        isOpen
        onClose={() => {
          blocker.reset();
          callBackLeave?.();
        }}
        onOk={() => {
          blocker.proceed();
          callBackLeave?.();
        }}
        labelClose="いいえ"
        labelOk="はい"
        width={500}
      >
        <Stack mb={2}>
          <Typography>{customMessage ?? "入力が完了していません。このまま戻ってもよろしいですか？"}</Typography>
        </Stack>
      </Modal>
    );
  }
  return null;
};
